import {QuoteItemGlassesTypeV2} from 'constants/flow/flowTypesCart';

export type PurchaseLensType = {options: Array<{title: string; option: {title: string}}> | {}};

/**
 * Get option by alias value
 * @param {QuoteItemGlassesTypeV2} product - quoteItem product
 * @param {string} alias - alias for search option
 * @returns {Object} required option
 */
export const getOptionByAlias = ({options = {}}: QuoteItemGlassesTypeV2, alias: string) =>
    options[Object.keys(options).find(option => options[option]?.option?.alias === alias) || ''];

/**
 * Get option by alias value
 * @param {PurchaseLensType} product - quoteItem product
 * @param {string} title - title for search option
 * @returns {Object} required option
 */
export const getOptionByTitleFromArray = ({options = []}: PurchaseLensType, title: string) => {
    if (!Array.isArray(options)) return {title: ''};
    return options.find(item => item?.option?.title === title);
};
